import { TaskService } from './../task.service';
import { CancelWorkflowDialogComponent } from './cancel-workflow-dialog/cancel-workflow-dialog.component';
import { AuthenticationGuard } from 'app/services/authentication-guard.service';
import { Component, OnInit,ChangeDetectorRef,  ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { ConstantsService } from 'app/services/constants-service';

@Component({
  selector: 'app-taskworkflow',
  templateUrl: './task-structure.component.html',
  styleUrls: ['./task-structure.component.css']
})

/**
 * Component for render the task workflow.
 */
export class TaskStructureComponent implements OnInit {
  entityId: number;
  imagePath: string;
  activeWorkflow:any;
  isAdmin: boolean;
  private image:any;
  dialogRef: MdDialogRef<any>;
  constructor(
    private authenticationGuard: AuthenticationGuard,
    private viewContainerRef: ViewContainerRef,
    private dialog: MdDialog,
    private taskservice: TaskService,
  ) {}

  ngOnInit() {
    this.image = ConstantsService.APP_BE_URL
      + ConstantsService.PROCESS_IMAGE_SERVLET
      + '?processId=' + this.activeWorkflow.id;
    this.isAdmin = this.authenticationGuard.isAdminUser();
  }

  openCancelWorkflowDialog(activeWorkFlow) {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(CancelWorkflowDialogComponent, config);
    this.dialogRef.componentInstance.entityId = this.entityId;
    this.dialogRef.componentInstance.activeWorkflow = activeWorkFlow;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/task/taskstructure/task-structure.component.ts